export const expertises = [
    {
      id: 1,
      title_fr: "Électricité",
      title_en: "Electricity",
      description_fr: "Nous concevons et réalisons des installations électriques sûres, performantes et évolutives, adaptées aux exigences des bâtiments modernes.",
      description_en: "We design and build safe, efficient, and scalable electrical installations tailored to the requirements of modern buildings.",
      subcategories: [
        {
          title_fr: "Installation & Rénovation Complète",
          title_en: "Installation & Complete Renovation",
          items_fr: [
            "Réseaux neufs et remise aux normes (NFC 15-100, normes incendie)",
            "Mise en sécurité des installations anciennes",
            "Câblage structuré pour bureaux, logements"
          ],
          items_en: [
            "New networks and upgrading to standards (NFC 15-100, fire standards)",
            "Securing old installations",
            "Structured cabling for offices, housing"
          ]
        },
        {
          title_fr: "Gestion Technique Centralisée",
          title_en: "Centralized Technical Management",
          items_fr: [
            "Pilotage intelligent des énergies (éclairage, chauffage, climatisation)",
            "Supervision des consommations via interfaces dédiées",
            "Intégration des automatismes"
          ],
          items_en: [
            "Intelligent energy management (lighting, heating, air conditioning)",
            "Consumption supervision via dedicated interfaces",
            "Integration of automation"
          ]
        },
        {
          title_fr: "Solutions Courants Faibles & Connectivité",
          title_en: "Low Voltage Solutions & Connectivity",
          items_fr: [
            "Réseaux VDI (Voix, Données, Images)",
            "Pré-câblage IoT et smart building",
            "Systèmes de sécurité (alarme, vidéosurveillance)"
          ],
          items_en: [
            "VDI networks (Voice, Data, Images)",
            "IoT pre-wiring and smart building",
            "Security systems (alarm, video surveillance)"
          ]
        },
        {
          title_fr: "Domotique & Bâtiment Intelligent",
          title_en: "Home Automation & Smart Building",
          items_fr: [
            "Solution d'automatisation",
            "Interfaces utilisateur simplifiées",
            "Contrôle et monitoring à distance"
          ],
          items_en: [
            "Automation solution",
            "Simplified user interfaces",
            "Remote control and monitoring"
          ]
        }
      ]
    },
    {
      id: 2,
      title_fr: "Réhabilitation de Bâtiments",
      title_en: "Building Rehabilitation",
      description_fr: "Nous transformons vos espaces avec des solutions sur-mesure, esthétiques et fonctionnelles pour tous types de bâtiments.",
      description_en: "We transform your spaces with tailor-made, aesthetic, and functional solutions for all types of buildings.",
      subcategories: [
        {
          title_fr: "Cloisonnement & Agencement",
          title_en: "Partitioning & Layout",
          items_fr: [
            "Cloisons sèches (placoplâtre, aluminium/verre)",
            "Séparation modulable de bureaux",
            "Aménagement d'espaces techniques",
            "Solutions acoustiques: insonorisation des murs et des portes",
            "Installation de cloisons sèches"
          ],
          items_en: [
            "Drywall (plasterboard, aluminum/glass)",
            "Modular office separation",
            "Technical spaces layout",
            "Acoustic solutions: soundproofing of walls and doors",
            "Drywall installation"
          ]
        },
        {
          title_fr: "Relooking Complet",
          title_en: "Complete Makeover",
          items_fr: [
            "Peinture professionnelle (intérieur/extérieur)",
            "Revêtements muraux (staff, lambris, panneaux 3D)",
            "Rénovation de sols (stratifié, PVC, carrelage)",
            "Plafonds tendus et faux-plafonds"
          ],
          items_en: [
            "Professional painting (interior/exterior)",
            "Wall coverings (staff, paneling, 3D panels)",
            "Floor renovation (laminate, PVC, tiling)",
            "Stretch ceilings and drop ceilings"
          ]
        },
        {
          title_fr: "Aménagement Sur-Mesure",
          title_en: "Tailor-made Layout",
          items_fr: [
            "Cuisines équipées",
            "Salles de bains modernes",
            "Espaces de réception",
            "Dressing et rangements"
          ],
          items_en: [
            "Fitted kitchens",
            "Modern bathrooms",
            "Reception areas",
            "Walk-in closets and storage"
          ]
        },
        {
          title_fr: "Menuiserie Intérieure",
          title_en: "Interior Carpentry",
          items_fr: [
            "Portes intérieures",
            "Habillages de gaines",
            "Placards intégrés",
            "Mobilier fixe"
          ],
          items_en: [
            "Interior doors",
            "Duct cladding",
            "Built-in cupboards",
            "Fixed furniture"
          ]
        }
      ]
    },
    {
      id: 3,
      title_fr: "Climatisation",
      title_en: "Air Conditioning",
      description_fr: "Nous concevons et installons des systèmes de climatisation performants, économes et adaptés à vos besoins, tout en garantissant une qualité d'air optimale pour vos espaces.",
      description_en: "We design and install high-performance, economical air conditioning systems tailored to your needs, while ensuring optimal air quality for your spaces.",
      subcategories: [
        {
          title_fr: "Installation & Rénovation de Systèmes CVC",
          title_en: "Installation & Renovation of HVAC Systems",
          items_fr: [
            "Climatisation mono-split, multi-split et VRV/VRF",
            "Mise aux normes et optimisation des installations existantes"
          ],
          items_en: [
            "Mono-split, multi-split, and VRV/VRF air conditioning",
            "Upgrading to standards and optimizing existing installations"
          ]
        },
        {
          title_fr: "Gestion Technique et Régulation Intelligente",
          title_en: "Technical Management and Intelligent Regulation",
          items_fr: [
            "Pilotage centralisé des systèmes (GTB/GTC)",
            "Supervision énergétique en temps réel"
          ],
          items_en: [
            "Centralized system control (BMS/BMCS)",
            "Real-time energy supervision"
          ]
        },
        {
          title_fr: "Maintenance Préventive et Curative",
          title_en: "Preventive and Corrective Maintenance",
          items_fr: [
            "Entretien",
            "Dépannage rapide 24h/24",
            "Nettoyage et contrôle des réseaux aérauliques"
          ],
          items_en: [
            "Maintenance",
            "Fast 24/7 troubleshooting",
            "Cleaning and checking of ventilation networks"
          ]
        }
      ]
    },
    {
      id: 4,
      title_fr: "Froid Industriel",
      title_en: "Industrial Refrigeration",
      description_fr: "Nous concevons et maintenons des installations frigorifiques performantes, fiables et économes, garantissant la parfaite conservation de vos produits sensibles.",
      description_en: "We design and maintain high-performance, reliable, and energy-efficient refrigeration installations, guaranteeing perfect preservation of your sensitive products.",
      subcategories: [
        {
          title_fr: "Installation Clé en Main",
          title_en: "Turnkey Installation",
          items_fr: [
            "Chambres froides positives & négatives",
            "Centrales frigorifiques sur mesure",
            "Vitrines réfrigérées et meubles de congélation",
            "Systèmes de froid industriel"
          ],
          items_en: [
            "Above and below-zero cold rooms",
            "Custom-made refrigeration units",
            "Refrigerated display cases and freezing furniture",
            "Industrial refrigeration systems"
          ]
        },
        {
          title_fr: "Maintenance Expertisée",
          title_en: "Expert Maintenance",
          items_fr: [
            "Recharge et récupération de fluides frigorigènes",
            "Optimisation énergétique des installations",
            "Entretiens & maintenances"
          ],
          items_en: [
            "Recharging and recovery of refrigerants",
            "Energy optimization of installations",
            "Servicing & maintenance"
          ]
        },
        {
          title_fr: "Solutions Spécialisées",
          title_en: "Specialized Solutions",
          items_fr: [
            "Salles blanches et laboratoires",
            "Froid alimentaire",
            "Chambres de maturation contrôlée",
            "Systèmes de surgélation rapide"
          ],
          items_en: [
            "Clean rooms and laboratories",
            "Food refrigeration",
            "Controlled ripening rooms",
            "Quick freezing systems"
          ]
        }
      ]
    },
    {
      id: 5,
      title_fr: "Plomberie & Sanitaires",
      title_en: "Plumbing & Sanitary",
      description_fr: "Nous proposons des solutions intégrées pour vos réseaux hydrauliques, alliant fiabilité, durabilité et conformité, afin de répondre à toutes vos exigences.",
      description_en: "We offer integrated solutions for your hydraulic networks, combining reliability, durability, and compliance to meet all your requirements.",
      subcategories: [
        {
          title_fr: "Installation & Rénovation Complète",
          title_en: "Installation & Complete Renovation",
          items_fr: [
            "Réseaux neufs et remise aux normes",
            "Mise en sécurité des installations existantes (détection fuites, remplacement canalisations)",
            "Distribution optimisée pour logements, ERP et bâtiments industriels"
          ],
          items_en: [
            "New networks and upgrading to standards",
            "Securing existing installations (leak detection, pipe replacement)",
            "Optimized distribution for housing, public buildings, and industrial buildings"
          ]
        },
        {
          title_fr: "Gestion des Fluides Techniques",
          title_en: "Management of Technical Fluids",
          items_fr: [
            "Réseaux d'eau potable et eaux usées",
            "Systèmes de chauffage hydraulique"
          ],
          items_en: [
            "Drinking water and wastewater networks",
            "Hydraulic heating systems"
          ]
        },
        {
          title_fr: "Solutions Sanitaires",
          title_en: "Sanitary Solutions",
          items_fr: [
            "Installation d'équipements (robinetterie, WC, douches)",
            "Protection contre la légionellose",
            "Optimisation des consommations d'eau"
          ],
          items_en: [
            "Equipment installation (faucets, toilets, showers)",
            "Protection against legionella",
            "Optimization of water consumption"
          ]
        },
        {
          title_fr: "Maintenance preventive et curative",
          title_en: "Preventive and Corrective Maintenance",
          items_fr: [
            "Détection précoce des fuites",
            "Interventions rapides 24h/24",
            "Entretien"
          ],
          items_en: [
            "Early leak detection",
            "Fast 24/7 interventions",
            "Maintenance"
          ]
        }
      ]
    },
    {
      id: 6,
      title_fr: "Énergies Alternatives & Renouvelables",
      title_en: "Alternative & Renewable Energies",
      description_fr: "Chez Auxis, nous développons des solutions énergétiques innovantes, durables et autonomes pour réduire votre dépendance aux réseaux traditionnels et optimiser vos coûts.",
      description_en: "At Auxis, we develop innovative, sustainable, and autonomous energy solutions to reduce your dependence on traditional networks and optimize your costs.",
      subcategories: [
        {
          title_fr: "Énergie Solaire",
          title_en: "Solar Energy",
          items_fr: [
            "Étude complète (technique, économique, environnementale,..)",
            "Installation de panneaux photovoltaïques (en toiture, sur ombrières ou au sol)",
            "Solutions connectées au réseau (on-grid) ou autonomes (off-grid)",
            "Raccordement au réseau électrique",
            "Optimisation des performances",
            "Services de maintenance et de suivi"
          ],
          items_en: [
            "Complete study (technical, economic, environmental...)",
            "Installation of photovoltaic panels (on roof, carports or ground)",
            "Grid-connected (on-grid) or autonomous (off-grid) solutions",
            "Connection to the electrical grid",
            "Performance optimization",
            "Maintenance and monitoring services"
          ]
        },
        {
          title_fr: "Groupes Électrogènes & Alimentation de Secours",
          title_en: "Generators & Backup Power",
          items_fr: [
            "Installation de groupes électrogènes",
            "Conception et installation de reseaux ondules et systèmes UPS pour sites sensibles",
            "Maintenance corrective",
            "Entretien périodique des installations électriques de secours"
          ],
          items_en: [
            "Generator installation",
            "Design and installation of UPS networks and UPS systems for sensitive sites",
            "Corrective maintenance",
            "Periodic maintenance of emergency electrical installations"
          ]
        },
        {
          title_fr: "Autres Solutions Énergétiques",
          title_en: "Other Energy Solutions",
          items_fr: [
            "Biogaz: Conception et installation de kit complet d'unités de méthanisation",
            "Systèmes hybrides (solaire + groupe électrogène)",
            "Etude & conception, installation d'autres systèmes d'ER (Éolien domestique, Microcentrale Hydraulique, Installation Biomasse et Systèmes de Cogénération,...)"
          ],
          items_en: [
            "Biogas: Design and installation of complete anaerobic digestion unit kits",
            "Hybrid systems (solar + generator)",
            "Study & design, installation of other RE systems (Domestic wind, Micro-hydro, Biomass Installation and Cogeneration Systems...)"
          ]
        }
      ]
    }
  ];